module.exports = __webpack_public_path__ + "img/shield.2991fbb5.svg";